import React, { Dispatch, ReactNode, SetStateAction, useState } from 'react';

type MatchCheckedInSelectionContextType = {
  selectedMembers: string[];
  toggleMember: (id: string) => void;
};

const MatchCheckedInSelectionContext = React.createContext<
  MatchCheckedInSelectionContextType | undefined
>(undefined);

export const MatchCheckedInSelectionProvider = ({
  children,
  externalState,
}: {
  children: ReactNode;
  externalState?: [string[], Dispatch<SetStateAction<string[]>>];
}) => {
  const [selectedMembers, setSelectedMembers] = externalState ?? useState<string[]>([]);

  const toggleMember = (id: string) => {
    setSelectedMembers((prev) =>
      prev.includes(id) ? prev.filter((mid) => mid !== id) : [...prev, id],
    );
  };

  return (
    <MatchCheckedInSelectionContext.Provider value={{ selectedMembers, toggleMember }}>
      {children}
    </MatchCheckedInSelectionContext.Provider>
  );
};

export const useMatchCheckedInSelection = (): MatchCheckedInSelectionContextType => {
  const context = React.useContext(MatchCheckedInSelectionContext);
  if (!context) {
    throw new Error(
      'useMatchCheckedInSelection must be used within a MatchCheckedInSelectionProvider',
    );
  }
  return context;
};
